/* eslint-disable no-restricted-globals */
import shared from './shared';

export default () => {
  const heroSections = document.querySelectorAll('.c-slider');

  if (heroSections.length < 1) {
    return;
  }

  [].forEach.call(heroSections, heroSection => {
    const slides = heroSection.querySelectorAll('.c-slider__slide');

    [].forEach.call(slides, slide => {
      const playButton = slide.querySelector('.c-slider__play[data-vimeo]');
      const videoContainer = slide.querySelector('.c-slider__video');

      if (playButton === null || videoContainer === null) {
        return;
      }

      const videoID = playButton.getAttribute('data-vimeo');

      playButton.addEventListener('click', event => {
        event.preventDefault();
        videoContainer.classList.add(shared.CSS.active);
        videoContainer.innerHTML = `<iframe src="https://player.vimeo.com/video/${videoID}?autoplay=1&title=0&byline=0&portrait=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`;
      });
    });

    if (slides.length < 2) {
      return;
    }

    const dots = heroSection.querySelectorAll('.c-slider__dot');
    let currentIndex = 0;
    const autoplayTime = heroSection.hasAttribute('data-autoplay')
      ? parseInt(heroSection.getAttribute('data-autoplay'), 10)
      : null;
    let autoplayTimeout = null;
    const setSlide = index => {
      dots[currentIndex].classList.remove(shared.CSS.active);
      slides[currentIndex].classList.remove(shared.CSS.active);
      currentIndex = index;
      dots[currentIndex].classList.add(shared.CSS.active);
      slides[currentIndex].classList.add(shared.CSS.active);

      if (autoplayTimeout !== null) {
        autoplayTimeout = setTimeout(() => {
          setSlide((currentIndex + 1) % slides.length);
        }, autoplayTime);
      }
    };

    [].forEach.call(dots, (dot, index) => {
      dot.addEventListener('click', event => {
        event.preventDefault();
        if (autoplayTimeout !== null) {
          clearInterval(autoplayTimeout);
          autoplayTimeout = null;
        }
        setSlide(index);
      });
    });

    if (!isNaN(autoplayTime) && autoplayTime !== null) {
      autoplayTimeout = setTimeout(() => {
        setSlide((currentIndex + 1) % slides.length);
      }, autoplayTime);
    }
  });
};



// WEBPACK FOOTER //
// ./wp/wp-content/themes/elefint-redesign-chisel/src/scripts/modules/slider.js